<template>

  <div>
    <div class="content-table">
      <!--  Head   -->
      <div class="header-row">
        <div
            class="cell"
            :style="{ width: columnWidth }"
            v-for="(head, index) in columnHeaders"
            :key="index"
        >
          {{ head.title }}
        </div>
        <div
            v-if="isDeleteBtn"
            class="cell"
            :style="{ width: '40px' }"
        ></div>
      </div>

      <!--  Body   -->
      <div
          v-for="(rowContent, index) in tableData"
          :key="index"
          class="row"
      >
        <div
            v-for="(cellContent, name, index) in rowContent"
            :key="index"
            :class="{'cell': fieldNames.includes(name)}"
            :style="[fieldNames.includes(name) ? {'width': columnWidth} : {}]"
        >
            {{ fieldNames.includes(name) ? cellContent : ''}}
        </div>
        <div
            v-if="isDeleteBtn"
            class="cell text-center pointer"
            :style="{ width: '40px', color: 'red' }"
            @click="$emit('onDeleteRowBtn', rowContent._id)"
        >
          X
        </div>
      </div>
    </div>

    <table-pagination
        v-if="totalRecords >= limit && isNeedPagination"
        class="mt-20 mb-30"
        :current-page="currentPage"
        :limit="limit"
        :total-records="totalRecords"
        @onClickPrev="onClickPrev"
        @onClickNext="onClickNext"
        @onClickNumberPage="onClickNumberPage($event)"
    />
  </div>
</template>

<script>
import TablePagination from "@/components/TablePagination.vue";

export default {
  name: 'ContentTable',
  components: {TablePagination},
  data: () => ({
    columnWidth: '100%',
    fieldNames: []
  }),
  props: {
    columnHeaders: {
      type: Array,
      default: () => [] // ['', '', '']
    },
    tableData: {
      type: Array,
      default: () => [] // [{}, {}, {}]
    },
    totalRecords: {
      type: Number,
    },
    limit: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
    isDeleteBtn:{
      type: Boolean,
    },
    isNeedPagination: {
      type: Boolean,
    }
  },

  created() {
    this.fieldNames = this.columnHeaders.map(head => head.field)
  },

  mounted() {
    if(!this.isDeleteBtn) {
      this.columnWidth = this.columnHeaders.length > 0 ? (100 / this.columnHeaders.length) + '%' : '100%';
    } else {
      if(this.columnHeaders.length > 0) {
        this.columnWidth = `calc((100% - 40px) / ${this.columnHeaders.length})`
      } else {
        this.columnWidth = 'calc(100% - 40px)'
      }
    }
  },

  methods: {
    onClickPrev() {
      this.$emit('onClickPrev')
    },
    onClickNext() {
      this.$emit('onClickNext')
    },
    onClickNumberPage(n) {
      this.$emit('onClickNumberPage', n)
    }
  }



}

</script>

<style scoped>

.content-table {
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  border: 1px solid #cde0c2;
  margin-bottom: 20px;
}

.header-row {
  background-color: #a1be93;
}

.header-row .cell {
  padding: 10px 15px;
  color: white;
  font-size: 18px;
}

.header-row, .row {
  display: flex;
}

.row {
  border-top: 1px solid #cde0c2;
  margin: 0 !important;
}

.row .cell {
  padding: 5px 10px;
}

.cell:not(:last-child) {
  border-right: 1px solid #cde0c2;
}

.row:hover {
  background-color: #e3eedd;
}

</style>
